
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/[year]/[raceUrlSlug]",
      function () {
        return require("private-next-pages/elections/[year]/[raceUrlSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/[year]/[raceUrlSlug]"])
      });
    }
  